var _g, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMutedVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5217 4.70683C22.4153 4.66598 22.313 4.64547 22.2147 4.64547C21.9937 4.64547 21.8097 4.72338 21.6623 4.87878L16.7147 9.81416V7.78851C16.7147 6.81443 16.3689 5.98178 15.6773 5.29012C14.9856 4.59855 14.153 4.25275 13.1789 4.25275H4.53613C3.56227 4.25275 2.72944 4.59855 2.03774 5.29012C1.3463 5.98178 1.00049 6.81443 1.00049 7.78851V16.4314C1.00049 17.4054 1.3463 18.238 2.03778 18.9296C2.72948 19.6212 3.56231 19.967 4.53618 19.967H13.1789C14.1531 19.967 14.9857 19.6212 15.6773 18.9296C16.369 18.238 16.7148 17.4054 16.7148 16.4314V14.3933L21.6624 19.3409C21.8098 19.4963 21.9938 19.5741 22.2148 19.5741C22.3131 19.5741 22.4154 19.5537 22.5218 19.5129C22.8411 19.3737 23.0006 19.1324 23.0006 18.7886V5.43134C23.0005 5.08742 22.841 4.84602 22.5217 4.70683Z",
    fill: "#4B9BF5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.6499,
    y: 20.5061,
    width: 2,
    height: 29,
    transform: "rotate(135 23.6499 20.5061)",
    fill: "#4B9BF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2358,
    y: 21.9203,
    width: 2,
    height: 29,
    transform: "rotate(135 22.2358 21.9203)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(1.00049 1.10986)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutedVideo);
export default __webpack_public_path__ + "static/media/muted_video.4ed703a6ce7ca40a7eb1426774121eb1.svg";
export { ForwardRef as ReactComponent };